import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { useNavigate } from "react-router-dom";

import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser, apiError, resetLoginFlag } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik validation
import logoLight from "../../assets/images/logo-light.png";

const Login = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, loginLoading, isLogin, error } = useSelector((state) => ({
    user: state.Register.user,
    loginLoading: state.Login.loading,
    isLogin: state.Login.isLogin,
    error: state.Login.error,
  }));
  const [userLogin, setUserLogin] = useState([]);
  useEffect(() => {
    if (user && user) {
      setUserLogin({
        username: user.data.username,
      });
    }
  }, [user]);

  useEffect(() => {
    if (isLogin) {
      navigate("/dashboard");
    }
  }, [isLogin, navigate]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      clientAppId: 2,
      username: userLogin.username || "",
      password: userLogin.password || "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  document.title = "Login | TELKOMSEL ";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className='auth-page-content'>
          <Container>
            <Row>
              <Col lg={12}>
                <div className='text-center mt-sm-5 mb-4 text-white-50'>
                  <div>
                    <a href='/' className='d-inline-block auth-logo'>
                      <img src={logoLight} alt='' height='90' />
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className='justify-content-center'>
              <Col md={8} lg={6} xl={5}>
                <Card className='mt-4'>
                  <CardBody className='p-4'>
                    <div className='text-center mt-2'>
                      <h5 className='text-primary'>Welcome Back !</h5>
                      <p className='text-muted'>
                        Sign in to continue to <br />
                        SMART IOT DASHBOARD .
                      </p>
                    </div>
                    <div className='p-2 mt-4'>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action='#'>
                        {error && error.response ? (
                          <Alert color='danger'>
                            <div>{error.response.data.message}</div>
                          </Alert>
                        ) : null}
                        <div className='mb-3'>
                          <Label htmlFor='username' className='form-label'>
                            Username
                          </Label>
                          <Input
                            name='username'
                            className='form-control'
                            placeholder='Enter username'
                            type='text'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.username || ""}
                            invalid={
                              validation.touched.username &&
                              validation.errors.username
                                ? true
                                : false
                            }
                          />
                          {validation.touched.username &&
                          validation.errors.username ? (
                            <FormFeedback type='invalid'>
                              {validation.errors.username}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className='mb-3'>
                          <Label
                            className='form-label'
                            htmlFor='password-input'>
                            Password
                          </Label>
                          <div className='position-relative auth-pass-inputgroup mb-3'>
                            <Input
                              name='password'
                              value={validation.values.password || ""}
                              type='password'
                              className='form-control pe-5'
                              placeholder='Enter Password'
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type='invalid'>
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              className='btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted'
                              type='button'
                              id='password-addon'>
                              <i className='ri-eye-fill align-middle'></i>
                            </button>
                          </div>
                        </div>

                        <div className='form-check'>
                          <Input
                            className='form-check-input'
                            type='checkbox'
                            value=''
                            id='auth-remember-check'
                          />
                          <Label
                            className='form-check-label'
                            htmlFor='auth-remember-check'>
                            Remember me
                          </Label>
                        </div>

                        <div className='mt-4'>
                          <Button
                            color='primary'
                            className='btn btn-primary w-100'
                            type='submit'>
                            Sign In{" "}
                            {loginLoading && (
                              <Spinner
                                size='sm'
                                className='flex-shrink-0'
                                role='status'>
                                Loading...
                              </Spinner>
                            )}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className='mt-4 text-center'>
                  <p className='mb-0'>
                    Do you not currently have an account ?{" "}
                    <Link
                      to='/register'
                      className='fw-semibold text-primary text-decoration-underline'>
                      {" "}
                      Register{" "}
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
